import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  colors: {
    synthwave: {
      50: '#fff3e6',  // Lightest orange
      100: '#ffe0cc',
      200: '#ffc299',
      300: '#ffa366',
      400: '#ff8533',  // Main orange
      500: '#ff6600',  // Bright orange
      600: '#cc5200',
      700: '#993d00',
      800: '#662900',
      900: '#331400'   // Darkest orange
    },
    brand: {
      primary: '#ff8533',    // Main orange
      secondary: '#ff33cc',   // Pink highlight
      accent: '#33ccff',      // Cyan accent
      background: '#1a1a2e'    // Dark blue background
    }
  },
  fonts: {
    heading: 'Montserrat, sans-serif',
    body: 'Open Sans, sans-serif'
  },
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: 'brand.background',
        color: 'white',
      },
    },
  },
})

export default theme
